import { Hero } from '@components/Hero';
import { MagazineNav } from '@components/Navigation';
import { FeatureArticle } from '@components/Sections/FeatureArticle';
import { StatsSection } from '@components/Sections/StatsSection';
import { PortfolioSection } from '@components/Sections/PortfolioSection';
import { ContactSection } from '@components/Sections/ContactSection';
import { QuoteBox } from '@components/UI/QuoteBox';
import { Footer } from '@components/UI/Footer';
import {
  personalInfo,
  navItems,
  issueInfo,
  coverStory,
  mainArticle,
  sidebarHighlights,
  testimonial,
  quoteText,
  stats,
  portfolioItems,
  contactMethods
} from '@data/content';
import './App.css';

function App() {
  return (
    <>
      <MagazineNav items={navItems} />

      <Hero
        firstName={personalInfo.firstName}
        lastName={personalInfo.lastName}
        portraitSrc={personalInfo.portraitSrc}
        portraitAlt={personalInfo.portraitAlt}
        issueInfo={issueInfo}
        coverStory={coverStory}
      />

      <FeatureArticle
        article={mainArticle}
        sidebarHighlights={sidebarHighlights}
        testimonial={testimonial}
      />

      <div className="page-break"></div>

      <QuoteBox quote={quoteText} />

      <StatsSection stats={stats} />

      <PortfolioSection items={portfolioItems} />

      <ContactSection contactMethods={contactMethods} />

      <Footer />
    </>
  );
}

export default App;
